'use strict';
import angular from 'angular';
import InternationalAdjustmentController from './adjustment-intership.controller';
import angularFilter from 'angular-filter';
export default angular.module('directives.adjustmentIntership', [
    angularFilter
])
    .component('adjustmentIntership', {
    template: require('./adjustment-intership.html'),
    controller: InternationalAdjustmentController,
    bindings: {
        itemsAdjusted: '<'
    }
})
    .name;
//# sourceMappingURL=index.js.map